import { connectedStore } from '../../store';
import getIntegrationSettings from '../selectors/settings';

const getSettings = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getIntegrationSettings(state);
};

export default getSettings;
